import { Collection } from '@domain/product/models/Collection';
import { CollectionDTO } from '../dto/CollectionDTO';
import { ProductMapper } from './ProductMapper';

export class CollectionMapper {
  static toModel(dto: CollectionDTO): Collection {
    return {
      id: dto.id,
      name: dto.name,
      products: dto.collectionProducts?.map((cp) => ProductMapper.toModel(cp.product)),
    };
  }
}
